import * as Yup from 'yup';

export const schema = Yup.object({
	cat_vat_taxes_id: Yup.mixed().notRequired().default(0),
	cat_vat_rates_id: Yup.mixed().notRequired().default(0),
	r_isr: Yup.mixed().notRequired().default(0),
	ieps: Yup.mixed().notRequired().default(''),
});
